import script from "./SettingsItemRegions.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItemRegions.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItemRegions.vue?vue&type=style&index=0&id=73335ef9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73335ef9"]])

export default __exports__